<template>
  <div style="height: 100%">

    <div class="site_homePage_title" style="margin-top: 10px">
      <div style="width: 45%;height: 70%; display: flex;flex-direction: row;align-items: center;justify-content: space-between">
      <div style="background-color: #0a84ff;height: 100%;width: 58%" class="site_homePage_title_inner">
        <div class="varchar_size" style="color: whitesmoke">{{'CW制造部' + ' ' + '组立品质状况'}}</div>
      </div>

      <div class="site_homePage_title_inner varchar_size" style="width: 40%;height: 100%">{{this.wujian_short_name}}</div>
      </div>

      <div class="site_homePage_title_inner">
        <div class="varchar_size">{{this.currentTime}}</div>
        <div class="varchar_size">{{this.week}}</div>
      </div>
    </div>

    <div class="pageContainer">

      <div class="asideContainer" style="border-right: 4px solid whitesmoke">

        <div class="size" style="height: 14%; margin-top: 10px">

          <div class="title">
            {{'组立日检查概况'}}
            <el-select v-model="lineId" style="width: 200px" @change="getZLUnitCheckInfo" clearable placeholder="产线选择" size="small" class="line_select_size">
              <el-option
                  v-for="item in lineNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="summary">

            <div class="messageCard" style="background-color: rgb(93, 201, 131)">
              <div class="message">{{'已检单元'}}</div>
              <h2 style="color: whitesmoke">{{this.checkedNum}}</h2>

            </div>

            <div class="messageCard" style="background-color: #0a84ff">
              <div class="message">{{'待确认'}}</div>
              <h2 style="color: whitesmoke">{{this.waitConfirm}}</h2>
            </div>

            <div class="messageCard" style="background-color: rgb(217, 154, 79)">
              <div class="message">{{'检查中'}}</div>
              <h2 style="color: whitesmoke">{{this.inCheck}}</h2>
            </div>

            <div class="messageCard" style="background-color: rgb(212, 109, 72)">
              <div class="message">{{'异常单元'}}</div>
              <h2 style="color: whitesmoke">{{this.badNum}}</h2>
            </div>

          </div>

        </div>

        <div class="size" style="height: 36%;">
          <div class="title" style="margin-top: 10px">
            {{'单元检查信息'}}
          </div>
          <el-table v-loading="loading" ref="table" id="infoTable" :data="tableData" height="90%"  style="width: 95%" :stripe="true">
            <el-table-column prop="wujian_id" label="物件番号"/>
            <el-table-column prop="unit_no" label="单元号" width="150px"/>
            <el-table-column label="组立" align="center">
              <template #default="props">
                <div v-if="props.row.checked_status === 'finish'" style="color: #1AB394;font-size: 18px">{{"✓"}}</div>
                <div v-if="props.row.checked_status === 'wait'">{{"——"}}</div>
                <div v-if="props.row.checked_status === 'inHand'">{{"检查中"}}</div>
              </template>
            </el-table-column>
            <el-table-column label="前部品" align="center">
              <template #default="props">
                <div v-if="props.row.qb_checked_status === 'finish'" style="color: #1AB394;font-size: 18px">{{"✓"}}</div>
                <div v-if="props.row.qb_checked_status === 'wait'">{{"——"}}</div>
                <div v-if="props.row.qb_checked_status === 'inHand'">{{"检查中"}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="玻璃">
              <template #default="props">
                <div v-if="props.row.bl_checked_status === 'finish'" style="color: #1AB394;font-size: 18px">{{"✓"}}</div>
                <div v-if="props.row.bl_checked_status === 'wait'">{{"——"}}</div>
                <div v-if="props.row.bl_checked_status === 'inHand'">{{"检查中"}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="后部品">
              <template #default="props">
                <div v-if="props.row.hb_checked_status === 'finish'" style="color: #1AB394;font-size: 18px">{{"✓"}}</div>
                <div v-if="props.row.hb_checked_status === 'wait'">{{"——"}}</div>
                <div v-if="props.row.hb_checked_status === 'inHand'">{{"检查中"}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="完成品">
              <template #default="props">
                <div v-if="props.row.wcp_checked_status === 'finish'" style="color: #1AB394;font-size: 18px">{{"✓"}}</div>
                <div v-if="props.row.wcp_checked_status === 'wait'">{{"——"}}</div>
                <div v-if="props.row.wcp_checked_status === 'inHand'">{{"检查中"}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template #default="props">
                <div v-if="props.row.confirm === 0">{{"未完检"}}</div>
                <div v-if="props.row.confirm === 1">{{"待确认"}}</div>
                <div v-if="props.row.confirm === 2" style="color: #1AB394;">{{"已确认"}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="size" style="height: 40%;border: none">
          <div class="title">
            {{'组立日不良堆积图'}}
            <div class="space-between">
              <el-date-picker v-model="drumDate.year" @change="getDrumChart" :clearable="false" format="YYYY 年" value-format="YYYY"  type="year" placeholder="年" style="width: 100px; margin-right: 5px"/>
              <el-date-picker v-model="drumDate.month" @change="getDrumChart" :clearable="false" format="MM 月" value-format="MM" type="month" placeholder="月" style="width: 80px; margin-right: 5px"/>
<!--              <el-date-picker v-model="currentDay" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px"/>-->
              <!--              <el-date-picker v-model="drumDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
            </div>
          </div>
          <div v-loading="drumChartLoading" element-loading-text="数据加载中" style="width: 90%;height: 80%" id="drumZuLi"/>
        </div>

      </div>

      <div class="asideContainer" style="border-left: 4px solid whitesmoke" >

        <div class="size" style="margin-top: 10px">
          <div class="title">
            <span>{{'组立不良项目数量占比'}}</span>
            <div class="space-between">
<!--              {{this.pieDate.year + "-" + pieDate.month + "-" + pieDate.day}}-->
              <el-date-picker @change="getPieChart"  v-model="pieDate.year" :clearable="false" format="YYYY 年" value-format="YYYY" type="year" placeholder="年" style="width: 100px; margin-right: 5px"/>
              <el-date-picker @change="getPieChart"  v-model="pieDate.month" :clearable="false" format="MM 月" value-format="MM" type="month" placeholder="月" style="width: 80px; margin-right: 5px"/>
<!--              <el-date-picker v-model="currentDay" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px"/>-->
              <el-date-picker @change="getPieChart"  v-model="pieDate.day" :clearable="false" format="DD 日" value-format="DD" type="day" placeholder="日" style="width: 80px"/>
            </div>
          </div>
          <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="width: 90%;height: 90%" id="pieZuLi"/>
        </div>

        <div class="size" style="height: 50%;border:none">
          <div class="title">
            {{'单元不良信息('+this.pieDate.year+'-'+this.pieDate.month+'-'+this.pieDate.day+')'}}
          </div>
<!--          <dv-scroll-board :config="zlBadInfo" style="width:90%;height:85%" />-->
          <el-table v-loading="tableBadDataLoading" :data="tableBadData" height="90%" style="width: 90%" :stripe="true">
            <el-table-column prop="unit_no" label="单元号" width="100"/>
<!--            <el-table-column prop="check_time" label="检查时间" width="180" />-->
            <el-table-column prop="ng_name" label="不良类别" width="180" align="center" />
            <el-table-column prop="remark" label="不良明细" width="300" align="center" />
            <el-table-column prop="ng_grade" label="不良等级" align="center" />
            <el-table-column prop="responsible_department" label="责任部门" align="center"/>
          </el-table>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { useDateFormat } from '@vueuse/core';
export default {
  name: "ZLSiteHomePage",
  data(){
    return {
      checkedNum:0,
      badNum:0,
      inCheck:0,
      waitConfirm:0,
      timer: null,
      wujian_id: '',
      wujian_short_name:'',
      currentTime: '',
      currentDay: this.getDateFormat(),
      week: "星期" + "日一二三四五六".charAt(new Date().getDay()),
      /*不良项目数量占比*/
      optionPie: {
        title: {
          text: '总数量',
          top: '45%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '26px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          textStyle: {
            fontSize:16
          },
          type: 'scroll',
          orient: 'horizontal',
          data: [
            {value: 1048, name: '二次胶不良'},
            {value: 735, name: '内脏'},
            {value: 580, name: '开裂'},
            {value: 484, name: '变形'},
            {value: 84, name: '擦伤,划伤'},
            {value: 44, name: '膜不良'},
            {value: 84, name: '爆边,爆角'},
            {value: 84, name: 'PVB不良'},
            {value: 44, name: '结石'},
            {value: 44, name: '叠差'},
            {value: 44, name: '表面凹坑'},
            {value: 44, name: '无应力'},
            {value: 44, name: '氩气不足'},
            {value: 300, name: '实物与标签不符'}
          ],
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '55%'],
            label: {
              show: true,
              fontSize:16,
              formatter: '{b},{d}%'
            },
            data: [
              {value: 44, name: '无应力'},
              {value: 84, name: '擦伤,划伤'},
              {value: 1048, name: '二次胶不良'},
              {value: 44, name: '膜不良'},
              {value: 735, name: '内脏'},
              {value: 44, name: '氩气不足'},
              {value: 84, name: 'PVB不良'},
              {value: 580, name: '开裂'},
              {value: 44, name: '叠差'},
              {value: 484, name: '变形'},
              {value: 44, name: '结石'},
              {value: 84, name: '爆边,爆角'},
              {value: 300, name: '实物与标签不符'},
              {value: 44, name: '表面凹坑'},
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieTimer:null,
      pieChartLoading: false,
      count:0,
      pieDate: {
        year: this.$common.getCurrentYearByMonth().toString(),
        month: this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        day: this.$common.getDateLabel(new Date().getDate()),
      },
      /*组立不良堆积图*/
      optionDrum: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `${params[0].name} <br/>`
            for (const item of params) {
              if (item.value !== 0) {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',            // 设置图例翻页
          orient: 'horizontal',     // 图例横向排布
          textStyle: {
            fontSize:16
          },
          data: [],              // title是一个列表，存着图例的数据
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            nameTextStyle: {
              fontSize: 18
            },axisLabel: {
              fontSize: 18,
            },
            data: [2109, 2110, 2111, 2112, 2201, 2202, 2203]
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            nameTextStyle: {
              fontSize: 18
            },
            axisLabel: {
              fontSize: 18,
            },
          }
        ],
        series: [
          {
            name: '无应力',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '擦伤,划伤',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '二次胶不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '膜不良',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: '内脏',
            type: 'bar',
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            emphasis: {
              focus: 'series'
            },
            markLine: {
              lineStyle: {
                type: 'dashed'
              },
              data: [[{type: 'min'}, {type: 'max'}]]
            }
          },
          {
            name: '氩气不足',
            type: 'bar',
            barWidth: 5,
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: [60, 73, 71, 74, 100, 130, 120]
          },
          {
            name: 'PVB不良',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 290, 230, 220]
          },
          {
            name: '开裂',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [60, 72, 71, 74, 190, 130, 110]
          },
          {
            name: '叠差',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '变形',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '结石',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '爆边,爆角',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '实物与标签不符',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          },
          {
            name: '表面凹坑',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
          }
        ]
      },
      drumChartLoading: false,
      drumTimer:null,
      drumDate: {
        year: this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        /*day:''*/
      },
      zlCheckInfo:[],
      checkInfoTimer:null,
      badInfoTimer:null,
      /*zlCheckInfo: {
        header: [
          '<span style="color: #1E3240;font-size: 18px">物件番号</span>',
          '<span style="color: #1E3240;font-size: 18px">单元号</span>',
          '<span style="color: #1E3240;font-size: 18px">组立</span>',
          '<span style="color: #1E3240;font-size: 18px">前部品</span>',
          '<span style="color: #1E3240;font-size: 18px">玻璃</span>',
          '<span style="color: #1E3240;font-size: 18px">后部品</span>',
          '<span style="color: #1E3240;font-size: 18px">完成品</span>',
          '<span style="color: #1E3240;font-size: 18px">状态</span>',
        ],
        data: [
          ['行1列1', '行1列2', '行1列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行2列1', '行2列2', '行2列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行3列1', '行3列2', '行3列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行4列1', '行4列2', '行4列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行5列1', '行5列2', '行5列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行6列1', '行6列2', '行6列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行7列1', '行7列2', '行7列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行8列1', '行8列2', '行8列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行9列1', '行9列2', '行9列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2'],
          ['行10列1', '行10列2', '行10列3','行1列1', '行1列2', '行1列3','行1列1', '行1列2']
        ],
        index: true,
        columnWidth: [50],
        align: ['center'],
        carousel: 'page',
        /!*headerBGC:"white",
        oddRowBGC:'white',
        evenRowBGC:'whitesmoke',*!/
      },*/
      zlBadInfo:[],
      /*zlBadInfo: {
        header: [
          '<span style="color: #1E3240;font-size: 18px">单元号</span>',
          '<span style="color: #1E3240;font-size: 18px">检查时间</span>',
          '<span style="color: #1E3240;font-size: 18px">不良类别</span>',
          '<span style="color: #1E3240;font-size: 18px">不良等级</span>',
          '<span style="color: #1E3240;font-size: 18px">责任部门</span>',
        ],
        data: [
          ['<span style="color: #1E3240">行1列1</span>', '行1列2', '行1列3', '行1列2', '行1列3'],
          ['行2列1', '行2列2', '行2列3', '行1列2', '行1列3'],
          ['行3列1', '行3列2', '行3列3', '行1列2', '行1列3'],
          ['行4列1', '行4列2', '行4列3', '行1列2', '行1列3'],
          ['行5列1', '行5列2', '行5列3', '行1列2', '行1列3'],
          ['行6列1', '行6列2', '行6列3', '行1列2', '行1列3'],
          ['行7列1', '行7列2', '行7列3', '行1列2', '行1列3'],
          ['行8列1', '行8列2', '行8列3', '行1列2', '行1列3'],
          ['行9列1', '行9列2', '行9列3', '行1列2', '行1列3'],
          ['行10列1', '行10列2', '行10列3', '行1列2', '行1列3']
        ],
        rowNum:10,
        index: true,
        columnWidth: [50],
        align: ['center'],
        carousel: 'page',
        headerBGC:"white",
        oddRowBGC:'white',
        evenRowBGC:'whitesmoke',
      }*/
      tableData:[],
      tableDataIdx:0,
      tableBadData:[],
      tableBadDataLoading:false,
      tableBadDataIdx:0,
      lineNames: [],
      lineId:'',
      loading:false
    }
  },
  methods: {
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
        /*let time
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/

        if (id === 'pieZuLi') {
          chart.on('legendselectchanged', function (params) {
            let array = []
            option.series[0].data.map((item)=>{
              if (params.selected[item.name]){
                array.push(item)
              }
            })
            option.legend.selected = params.selected
            option.title.text = "合计\n" + _this.$common.getPieSum(array)
            chart.clear()
            chart.setOption(option)
          })
        }
      }
    },

    getPieChartDate(){
      let pieTime
      clearTimeout(pieTime)
      pieTime = setTimeout(()=>{
        this.getPieChart()
      },4000)
    },

    async getPieChart() {
     /* this.pieDate.year =  this.$common.getCurrentYearByMonth().toString()
      this.pieDate.month = (new Date().getUTCMonth() + 1).toString()*/
      //this.pieDate.day = (new Date().getDate() - 1).toString()
      this.count += 1
      this.pieChartLoading = true
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/getToDayPieData',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.optionPie.title.text = "合计\n" + this.$common.getPieSum(this.optionPie.series[0].data)
      if (this.$common.getPieSum(this.optionPie.series[0].data) === 0){
        clearInterval(this.pieTimer)
        this.pieDate = this.$common.getLastDay(this.pieDate)
        await this.getPieChart()
      }else {
        await this.getZLUnitBadData()
        this.count = 0
        this.renderEcharts('pieZuLi', this.optionPie)
        this.pieChartLoading = false
        clearInterval(this.pieTimer)
        let timeout = 30000
        if (new Date().getHours() >= 12){
          timeout = 300000
        }
        this.pieTimer = setInterval(() => {
          this.getPieChart()
        }, timeout)
      }
    },

    async getDrumChart() {
     /* this.drumDate.year =  this.$common.getCurrentYearByMonth().toString()
      this.drumDate.month = new Date().getUTCMonth() + 1*/
      this.drumChartLoading = true
      this.drumDate.wujian_id = this.wujian_id
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/siteDrumChart',this.drumDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionDrum.xAxis[0].data = res.data.XDay
        this.optionDrum.series = res.data.drumSeries
        this.optionDrum.legend.data = res.data.drumSeries
        this.renderEcharts('drumZuLi', this.optionDrum)
      }
      clearInterval(this.drumTimer)
      this.drumTimer = setInterval(()=>{
        this.getDrumChart()
      },1800000)

      this.drumChartLoading = false
    },

    async getZLUnitBadData() {
      this.tableBadDataLoading = true
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/getZLUnitBadData',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.zlBadInfo = res.data
      }
      clearInterval(this.badInfoTimer)
      this.refreshBadData(this.zlBadInfo,7)
      this.badInfoTimer  = setInterval(()=>{
        this.refreshBadData(this.zlBadInfo,7)
      },15000)
      this.tableBadDataLoading = false
    },

    async getZLUnitCheckInfo() {
      this.loading = true
      clearInterval(this.checkInfoTimer)
      this.zlCheckInfo = []
      let query = {
        wujian_id:this.wujian_id,
        date:this.$common.getCurrentYearByMonth().toString() + '-' + (new Date().getUTCMonth() + 1).toString() + '-' + new Date().getDate().toString(),
        line_id:this.lineId
      }
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/getZLUnitCheckInfo',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.zlCheckInfo = res.data.data
      this.checkedNum = res.data.checkedNum
      this.waitConfirm = res.data.waitConfirm
      this.inCheck = res.data.inCheck
      this.badNum = res.data.badNum
      this.loading = false
      this.checkInfoTimer  = setInterval(()=>{
        this.refreshTableData(this.zlCheckInfo,5)
      },5000)
    },

    async getWuJianShortName() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianShortName',this.wujian_id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.wujian_short_name = res.data
    },

    //产线信息
    async getLineInFo() {
      let {data: res} = await this.$axios.post('am/homePage/getLineInFo');
      if (res.code !== 0) {
        this.$message.error('获取【产线信息】失败')
        return;
      }
      this.lineNames = res.data;
    },

    dateFormat(){
      this.currentTime = useDateFormat(new Date(), 'YYYY年-M月-DD日 HH:mm:ss')
    },

    refreshTableData(tableData,refreshNum){
      this.tableData = []
      for (let i = this.tableDataIdx; i < this.tableDataIdx + refreshNum; i++) {
        if (i < tableData.length) {
          this.tableData.push(tableData[i])
        }
      }
      this.tableDataIdx += refreshNum
      if (this.tableDataIdx >= tableData.length){
        this.getZLUnitCheckInfo()
        this.tableDataIdx = 0
      }
    },

    refreshBadData(tableData,refreshNum){
      this.tableBadData = []
      for (let i = this.tableBadDataIdx; i < this.tableBadDataIdx + refreshNum; i++) {
        if (i < tableData.length) {
          this.tableBadData.push(tableData[i])
        }
      }
      this.tableBadDataIdx += refreshNum
      if (this.tableBadDataIdx >= tableData.length){
        setTimeout(()=>{
          this.getZLUnitBadData()
        },15000)
        this.tableBadDataIdx = 0
      }
    },

  },

  created() {
    this.wujian_id = this.$route.params.key
    this.pieDate = this.$common.getLastDay(this.pieDate)
    this.pieDate.wujian_id = this.$route.params.key
    //this.getZLUnitBadData()
    this.getWuJianShortName()
    this.getZLUnitCheckInfo()
    this.getLineInFo()
  },

  mounted(){
    this.timer = setInterval(()=>{
      this.dateFormat();
    }, 1000)
    this.getPieChart()
    this.getDrumChart()
  },

  unmounted() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.badInfoTimer) {
      clearInterval(this.badInfoTimer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.checkInfoTimer) {
      clearInterval(this.checkInfoTimer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.pieTimer) {
      clearInterval(this.pieTimer); // 在Vue实例销毁前，清除我们的定时器
    }
  }

}
</script>

<style scoped>
.topContainer{
  display: flex;
  flex-direction: row;
}

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.asideContainer{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:  flex-start;
  align-items: center;
}

.wujian_size{
  width: 940px;
  height: 200px
}

.size{
  height: 40%;
  justify-content: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 22px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.summary{
  width: 90%;
  height: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.messageCard{
  width: 130px;
  height: 70px;
  background-color:whitesmoke;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  font-size: 20px;
  color: whitesmoke;
  border-radius: 5px;
}

.chart_size{
  width: 95%;
  height: 75%;
}
</style>